/** Business timezone: Singapore (SGT, UTC+8, no DST). */
export const APP_TIMEZONE = 'Asia/Singapore';

/** Return YYYY-MM-DD for a Date in Singapore time. */
export function formatYmd(date = new Date()) {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: APP_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

export function todayYmd() {
  return formatYmd(new Date());
}

/** Calendar date in Singapore time, offset by whole days from now. */
export function addDaysYmd(days) {
  return formatYmd(new Date(Date.now() + days * 24 * 60 * 60 * 1000));
}

export function formatDateTime(dt) {
  if (!dt) return '—';
  const d = new Date(dt);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-GB', {
    timeZone: APP_TIMEZONE,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatTime(dt) {
  if (!dt) return '—';
  const d = new Date(dt);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleTimeString('en-GB', {
    timeZone: APP_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}
